import React from 'react';
import Player from './Player/Player';
import { ILesson } from '../../../../types/ThemeType';
import VideoDescription from './VideoDescription/VideoDescription';
import classes from '../style/Theme.module.css';
import { Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
const PlayerDescription = ({
  data,
  quantityLessons,
  handleClick,
}: {
  data: ILesson;
  quantityLessons: number;
  handleClick: (id: number, order: number, method: string) => void;
}) => {
  let link = null;
  if (data.video_link !== null) {
    const params = new URLSearchParams(data.video_link.split('?')[1]);
    if (params.size !== 0) link = params.get('v');
    else link = data.video_link.split('/')[data.video_link.split('/').length - 1];
  }
  return (
    <>
      {data.video_path !== null ? (
        <div className={classes.player}>
          <Player
            title={data.title}
            order={data.lesson_order}
            link={data.video_link}
            access_token={localStorage.getItem('access_token') ?? ''}
            id={data.id}
          />
        </div>
      ) : (
        <h1>{`Урок ${data.lesson_order}. ${data.title}`}</h1>
      )}
      <h1>Темы, рассматриваемые в уроке:</h1>
      {data.description && (
        <VideoDescription description={data.description} isLink={data.video_link !== null} />
      )}
      <div className={classes.buttonWrapper}>
        <Button
          disabled={data.lesson_order > 1 ? false : true}
          onClick={() => handleClick(-1, data.lesson_order, 'decrement')}
        >
          Назад
        </Button>
        <Button
          className={classes.button}
          disabled={data.lesson_order < quantityLessons ? false : true}
          onClick={() => handleClick(-1, data.lesson_order, 'increment')}
        >
          Следующий урок
          <ArrowRightOutlined />
        </Button>
      </div>
    </>
  );
};

export default PlayerDescription;
